module.exports = __webpack_public_path__ + "static/media/working.33d78d5a.svg";